/**
 * File: referenceBookPreview.js
 * Project: educore
 * Created Date: 2019-01-14
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class ReferenceBookPreviewController {
    // @ngInject
    constructor($scope, $state, $rootScope, $sce, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //On destroy function
        this.$onDestroy = () => {}

        let userId = localStorageService.get("user_id")
        let planId = $state.params.planId;
        let plan = localStorageService.get("currentPlan")
        let authoring = localStorageService.get("authoringData")
        let resourceId = $state.params.resourceId;

        $scope.toogleResource = "Show Details";
        var screenLen = screen.width;
        if (screenLen < 1281) {
            $scope.isShow = false;
        } else {
            $scope.isShow = true;
        }

        $scope.gotoSite = (site) => {
            if (site.indexOf("http") === -1) {
                site = "http://" + site
            }
            window.open(site, "_blank")

        }

        var loadTemplate = () => {
            if (plan) {
                $scope.resource = _.find(plan.resources, function(res) {
                    return res._id === resourceId
                })
                if ($scope.userPrev.viewReferenceBook && $scope.userPrev.viewReferenceBook.read && ($scope.userPrev.addReferenceBook == undefined || ($scope.userPrev.addReferenceBook && !$scope.userPrev.addReferenceBook.create)) && ($scope.userPrev.approveReferenceBook == undefined || ($scope.userPrev.approveReferenceBook && !$scope.userPrev.approveReferenceBook.create))) {
                    try {
                        var data = {
                            resource: {
                                type: $scope.resource.type,
                                subject_id: authoring.subject_id,
                                class_id: authoring.class_id,
                                curriculum_id: authoring.curriculum_id,
                                batch_id: authoring.batch_id,
                                session_id: authoring.session_id,
                                school_id: authoring.school_id,
                                theme_id: plan.theme_id,
                                plan_id: planId,
                                progress_data: {
                                    _id: resourceId,
                                    title: $scope.resource.title
                                }
                            },
                            user_id: userId
                        }
                        authService.callAPI(TPWIZARDCONSTANT.API_ADD_LEARNING_PROGRESS, "POST", data, () => {})
                    } catch (ex) {}

                }
                if ($scope.resource) {
                    if ($scope.resource.web_link) {
                        $scope.isAvailable = true
                        let site = $scope.resource.web_link;
                        if (site.indexOf("http") === -1) {
                            site = "http://" + site
                        }
                        $scope.src = $sce.trustAsResourceUrl(site)
                    }
                }
                _.defer(() => { $scope.$apply(); });
            }
        }

        //Show details of WebLinks
        $scope.viewResource = () => {
            $scope.isShow = !$scope.isShow
            $scope.toogleResource = $scope.isShow ? "Hide Details" : "Show Details"
        }

         /*Roles and Privilege*/
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "refbooks"
        })
        $scope.userPrev = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userPrev[tpObj.feature_id] = user_access;
            })
            loadTemplate()
        }

    };
}

export default ReferenceBookPreviewController;


// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/resources/referenceBookPreview.js